import ErrorAlert from "@/utility/ErrorAlert";
import http from "@/axios/http-common";
import { isEmpty } from "lodash";

const BASE = "/monitoring-intra-op-lokal";

async function create(data) {
  const r = await http.postData(BASE, data).catch(err => {
    ErrorAlert.showErrorAlert(err);
    return Promise.reject(err);
  });
  return r;
}

async function update(id: number, data) {
  const r = await http.putData(`${BASE}/${id}`, data).catch(err => {
    ErrorAlert.showErrorAlert(err);
    return Promise.reject(err);
  });
  return r;
}

async function find(id: number) {
  const r = await http.getData(`${BASE}/${id}`).catch(err => {
    ErrorAlert.showErrorAlert(err);
    return Promise.reject(err);
  });
  return r;
}

async function getByRegister(registerId: string | number) {
  const r = await http.getData(`/register/${registerId}/monitoring-intra-op-lokal`).catch(err => {
    ErrorAlert.showErrorAlert(err);
    return Promise.reject(err);
  });
  return r;
}

async function destroy(id: number) {
  const r = await http.deleteData(`${BASE}/${id}`).catch(err => {
    ErrorAlert.showErrorAlert(err);
    return Promise.reject(err);
  });
  return isEmpty(r?.data) ? null : r.data;
}

async function addTtv(id: number, data) {
  const r = await http.postData(`${BASE}/${id}/ttv`, data).catch(err => {
    ErrorAlert.showErrorAlert(err);
    return Promise.reject(err);
  });
  return r;
}

async function updateTtv(id: number, ttvId: number, data) {
  const r = await http.putData(`${BASE}/${id}/ttv/${ttvId}`, data).catch(err => {
    ErrorAlert.showErrorAlert(err);
    return Promise.reject(err);
  });
  return r;
}

async function deleteTtv(id: number, ttvId: number) {
  const r = await http.deleteData(`${BASE}/${id}/ttv/${ttvId}`).catch(err => {
    ErrorAlert.showErrorAlert(err);
    return Promise.reject(err);
  });
  return r;
}

async function signOperator(id: number, payload: { password: string }) {
  const r = await http.putData(`${BASE}/${id}/sign-operator`, payload).catch(err => {
    ErrorAlert.showErrorAlert(err);
    return Promise.reject(err);
  });
  return r;
}

async function signPerawat(id: number, payload: { password: string }) {
  const r = await http.putData(`${BASE}/${id}/sign-perawat`, payload).catch(err => {
    ErrorAlert.showErrorAlert(err);
    return Promise.reject(err);
  });
  return r;
}

async function calculateDose(payload: {
  agen?: string | null;
  bb_kg?: number | null;
  volume_ml?: number | null;
  konsentrasi_persen?: number | null;
  vasokonstriktor?: string | null;
  total_dosis_mg?: number | null;
}) {
  const r = await http.postData(`${BASE}/calculate-dose`, payload).catch(err => {
    ErrorAlert.showErrorAlert(err);
    return Promise.reject(err);
  });
  return r;
}

function print(id: number) {
  window.open(`${http.getAPI()}${BASE}/${id}/pdf`, "_blank");
}

export default {
  create,
  update,
  find,
  getByRegister,
  destroy,
  addTtv,
  updateTtv,
  deleteTtv,
  signOperator,
  signPerawat,
  calculateDose,
  print,
};
